<filter-view-layout
	*ngIf="(currentView$ | async) as currentView"
	#folderContainer>
	<div class="filter-bar" filter-view-filter-bar [hidden]="dataSourceZeroState.hasZeroState && dataSourceZeroState.errorCode !== 0">
		<div [formGroup]="form">
			<div class="filter-container">
				<mat-form-field goSelect>
					<mat-label>{{ 'common_filter-by' | translate}}</mat-label>
					<mat-select
						formControlName="filterBy"
						disableOptionCentering
						panelClass="offsetPanel">
						<mat-option
							*ngFor="let option of filterOptions"
							[value]="option">
							{{ filterTranslations[option] | translate }}
						</mat-option>
					</mat-select>
				</mat-form-field>
			</div>

			<div class="sort-container">
				<mat-form-field goSelect>
					<mat-label>{{ 'common_sort-by' | translate }}</mat-label>
					<mat-select
						formControlName="sortBy"
						disableOptionCentering
						panelClass="offsetPanel">
						<mat-option
							*ngFor="let option of sortByOptions"
							[value]="option">
							{{ sortOrderTranslations[option] | translate }}
						</mat-option>
					</mat-select>
				</mat-form-field>
				<button
					*ngIf="showReorderActivities$ | async"
					type="button"
					class="btn-none reorder-btn"
					[matTooltip]="'folder_view-reorder-activities' | translate"
					matTooltipPosition="above"
					(click)="sortActivities()">
					<i class="ficon-cog"></i>
				</button>
			</div>
		</div>
	</div>

	<div class="filter-option" filter-view-options-bar [hidden]="dataSourceZeroState.hasZeroState">
		<button *ngIf="(activityListDataSource.results$ | async)?.length && currentView === views.LIST"
			type="button"
			class="icon-btn view-switcher ficon-app-grid"
			data-cy="change-to-grid"
			[matTooltip]="'change-to-grid-view' | translate"
			matTooltipPosition="left"
			(click)="viewStateDataSource.toggleCurrentView()"></button>
		<button *ngIf="(activityListDataSource.results$ | async)?.length && currentView === views.GRID"
			type="button"
			class="icon-btn view-switcher ficon-app-list"
			data-cy="change-to-list"
			[matTooltip]="'change-to-list-view' | translate"
			matTooltipPosition="left"
			(click)="viewStateDataSource.toggleCurrentView()"></button>
	</div>

	<div class="filter-content"
		filter-view-content
		*ngIf="!dataSourceZeroState.hasZeroState && !dataSourceZeroState.isLoading"
		(contextmenu)="openMenu($event)">
		<ng-container *ngIf="(activityListDataSource.results$ | async)?.length !== 0; else zeroState">
			<div class="grid-view" *ngIf="currentView === views.GRID">
				<activity-grid-view></activity-grid-view>
			</div>

			<div class="list-view" *ngIf="currentView === views.LIST">
				<activity-table-view (goToActivity)="goToActivity($event)"></activity-table-view>
			</div>
		</ng-container>

		<ng-template #zeroState>
			<folder-zero-state
				(openAssignmentSourceModal)="openAssignmentSourceModal()"
				(openInvite)="openInviteModal()"
				[hasInstructorRoleOrAbove]="hasInstructorRoleOrAbove()"
			></folder-zero-state>
		</ng-template>

		<menu *ngIf="hasInstructorRoleOrAbove() && (canCreateActivity$$ | async)">
			<course-context-menu
				[canCreateActivity]="canCreateActivity$$ | async"
				[canReorderActivities]="canReorderActivities$ | async"
				(onInvite)="openInviteModal()"
				(onCreateActivity)="openAssignmentSourceModal()"
				(onSortActivities)="sortActivities()">
			</course-context-menu>
		</menu>
	</div>

	<!-- Datasource zero state -->
	<div class="filter-zero-state" filter-view-content [hidden]="!dataSourceZeroState.hasZeroState && !dataSourceZeroState.isLoading">
		<data-source-zero-state [dataSource]="activityListDataSource" (zeroStateChanged)="zeroStateChanged($event)"></data-source-zero-state>
	</div>

	<div class="filter-action" filter-view-action-bar [hidden]="dataSourceZeroState.hasZeroState">
		<button
			*ngIf="!isLti() && shouldShowFooterButtons$ | async"
			class="secondary-btn invite-btn"
			(click)="openInviteModal()"
			translate>
			common_invite
		</button>
		<span
			[tabindex]="(canCreateActivity$$ | async) ? -1 : 0"
			[matTooltip]="getActivityCreationDisabledMessage$$ | async"
			[matTooltipDisabled]="canCreateActivity$$ | async"
			[attr.aria-disabled]="(canCreateActivity$$ | async) === false"
			matTooltipPosition="above"
			[attr.role]="(canCreateActivity$$ | async) === false ? 'button' : ''">
			<button
				*ngIf="shouldShowFooterButtons$ | async"
				data-cy="create-assignment"
				class="btn primary-btn create-btn"
				(click)="openAssignmentSourceModal()"
				[disabled]="(isCreating$ | async) || (canCreateActivity$$ | async) === false"
				[attr.aria-hidden]="(isCreating$ | async) || (canCreateActivity$$ | async) === false"
				translate>
				folder_view-create_button
				<i *ngIf="isCreating$ | async" class="ficon-spinner ficon-spin" aria-live="polite" attr.aria-label="{{'common_loading'| translate}}"></i>
			</button>
		</span>
	</div>
</filter-view-layout>
